/*
|--------------------------------------------------------------------------
| GH Web App Admin
|--------------------------------------------------------------------------
*/
var _$ 	= _$ || {};